import { ApplicationState } from '../..';

export const otherAttachment = (state: ApplicationState, index: number) => state.details.detailsOtherAttachments.otherAttachments[index];
export const claimNotificationId = (state: ApplicationState) => state.caseState.selectedCase.claimNotificationId;
